/**
 * @generated SignedSource<<8fe0e09f19737a23e2c1d94cb48f72ba>>
 * @relayHash 64668f798144348db0f9a36649dcd11c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/564.0.0-2026-06-16T17:18:36.716Z/HpSharedVideoComponentVideoQuery

import { ConcreteRequest } from 'relay-runtime';
export type HpSharedVideoComponentVideoQuery$variables = {
  isMuxVideo: boolean;
  videoId: string;
};
export type HpSharedVideoComponentVideoQuery$data = {
  readonly viewer: {
    readonly video?: {
      readonly desktopFile: {
        readonly link: string | null;
      } | null;
      readonly mobileFile: {
        readonly link: string | null;
      } | null;
    } | null;
  };
};
export type HpSharedVideoComponentVideoQuery = {
  response: HpSharedVideoComponentVideoQuery$data;
  variables: HpSharedVideoComponentVideoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMuxVideo"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "videoId"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "link",
    "storageKey": null
  }
],
v3 = {
  "condition": "isMuxVideo",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "videoId",
          "variableName": "videoId"
        }
      ],
      "concreteType": "VideoVimeo",
      "kind": "LinkedField",
      "name": "video",
      "plural": false,
      "selections": [
        {
          "alias": "desktopFile",
          "args": [
            {
              "kind": "Literal",
              "name": "size",
              "value": "w960h540"
            }
          ],
          "concreteType": "VideoVimeoFile",
          "kind": "LinkedField",
          "name": "fileByVideoSize",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": "fileByVideoSize(size:\"w960h540\")"
        },
        {
          "alias": "mobileFile",
          "args": [
            {
              "kind": "Literal",
              "name": "size",
              "value": "w426h240"
            }
          ],
          "concreteType": "VideoVimeoFile",
          "kind": "LinkedField",
          "name": "fileByVideoSize",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": "fileByVideoSize(size:\"w426h240\")"
        }
      ],
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HpSharedVideoComponentVideoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HpSharedVideoComponentVideoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/564.0.0-2026-06-16T17:18:36.716Z/HpSharedVideoComponentVideoQuery",
    "metadata": {},
    "name": "HpSharedVideoComponentVideoQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f2518d7560839272387f0e9515e45bce";

export default node;
